import { SEO } from "@/components/SEO";
import { Button } from "@/components/motion/Button";

export default function NotFound() {
  return (
    <>
      <SEO title="Seite nicht gefunden" />
      <section className="bg-paper min-h-[80svh] flex items-end pb-24 pt-40">
        <div className="container-x">
          <p className="label text-mute mb-8">404</p>
          <h1 className="display text-5xl sm:text-6xl lg:text-7xl text-ink">Diese Seite<br />gibt es nicht.</h1>
          <div className="mt-12"><Button to="/">Zur Startseite</Button></div>
        </div>
      </section>
    </>
  );
}
